/** "1 objetivo", "2 objetivos". */
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** O que o modelo traz, em texto: "4 perspectivas · 1 objetivo · 1 KPI". */
export const templateCounts = (c: { perspectives: number; objectives: number; kpis: number }) =>
  `${plural(c.perspectives, 'perspectiva', 'perspectivas')} · ${plural(c.objectives, 'objetivo', 'objetivos')} · ${plural(c.kpis, 'KPI', 'KPIs')}`;
